export default {
  namespaced: true,
  state: {
    codigoPromocion: null,
    codigoActivo: null,
    numOportunidad: null,
    alquiler: false,
    datosContacto: null,
    usuarioComercial: null
  },
  mutations: {
    codigoPromocion (state, payload) {
      state.codigoPromocion = payload
    },
    codigoActivo (state, payload) {
      state.codigoActivo = payload
    },
    numOportunidad (state, payload) {
      state.numOportunidad = payload
    },
    alquiler (state, payload) {
      state.alquiler = payload
    },
    datosContacto (state, payload) {
      state.datosContacto = payload
    },
    usuarioComercial (state, payload) {
      state.usuarioComercial = payload
    }
  },
  actions: {
    codigoPromocion ({ commit }, codigoPromocion) {
      commit('codigoPromocion', codigoPromocion)
    },
    codigoActivo ({ commit }, codigoActivo) {
      commit('codigoActivo', codigoActivo)
    },
    numOportunidad ({ commit }, numOportunidad) {
      commit('numOportunidad', numOportunidad)
    },
    alquiler ({ commit }, alquiler) {
      commit('alquiler', alquiler)
    },
    datosContacto ({ commit }, datosContacto) {
      commit('datosContacto', datosContacto)
    },
    usuarioComercial ({ commit }, usuarioComercial) {
      commit('usuarioComercial', usuarioComercial)
    }
  },
  getters: {
    codigoPromocion (state) {
      return state.codigoPromocion
    },
    codigoActivo (state) {
      return state.codigoActivo
    },
    numOportunidad (state) {
      return state.numOportunidad
    },
    alquiler (state) {
      return state.alquiler
    },
    datosContacto (state) {
      return state.datosContacto
    },
    usuarioComercial (state) {
      return state.usuarioComercial
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/incrustado/store.js